// src/utils/lineTaxCheck.js — taxlines1-f2503245 (tax codes on every line, Stage S1)
//
// "Complete & Invoice" and batch invoicing charge each line its own tax code. When a line's
// QuickBooks code wasn't in Spatchy's copy of the company's QuickBooks codes (even after one
// refresh), that line was charged the company's standard rate and the server marked the invoice
// with `lineTaxCodeCheck` (functions/utils/serverTotals.js). Staff screens show an amber banner;
// the first save by an office role (Owner / Admin / Manager / Office Staff — canBatchInvoice)
// removes the mark. STAFF ONLY: the portal, PDFs and emails never read it (testNoCostLeak poisons it).
import { canBatchInvoice } from './permissions';

export const LINE_TAX_CHECK_TEXT = "Tax for one or more lines couldn't be checked against QuickBooks and was charged at your standard rate. Check this invoice before sending.";

/** The mark on this invoice, or null. */
export const lineTaxCheckOf = (invoice) => {
    const m = invoice && invoice.lineTaxCodeCheck;
    return m && typeof m === 'object' && !Array.isArray(m) ? m : null;
};

/** Does a save by this user clear the mark? Office roles only. */
export const clearsLineTaxCheck = (user) => canBatchInvoice(user);
